/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClassificationPositionRequest
 */
export interface ClassificationPositionRequest {
    /**
     * 
     * @type {number}
     * @memberof ClassificationPositionRequest
     */
    position: number;
    /**
     * 
     * @type {string}
     * @memberof ClassificationPositionRequest
     */
    teamId?: string | null;
}

/**
 * Check if a given object implements the ClassificationPositionRequest interface.
 */
export function instanceOfClassificationPositionRequest(value: object): value is ClassificationPositionRequest {
    if (!('position' in value) || value['position'] === undefined) return false;
    return true;
}

export function ClassificationPositionRequestFromJSON(json: any): ClassificationPositionRequest {
    return ClassificationPositionRequestFromJSONTyped(json, false);
}

export function ClassificationPositionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassificationPositionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'position': json['position'],
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
    };
}

export function ClassificationPositionRequestToJSON(json: any): ClassificationPositionRequest {
    return ClassificationPositionRequestToJSONTyped(json, false);
}

export function ClassificationPositionRequestToJSONTyped(value?: ClassificationPositionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'position': value['position'],
        'teamId': value['teamId'],
    };
}

